import { DisqualifiedCard } from './DisqualifiedCard'
import { NextStepsCard } from './NextStepsCard'
import { useNextStepsActions } from './useNextStepsActions'
import { useReportEndCardSlot } from './useReportEndCardSlot'

interface ReportEndCardProps {
  attentionCount: number
  /** Whether this practice qualifies for a consult; decided by the API at intake submit. */
  isPql: boolean
}

/**
 * Renders whichever closing card this practice has earned. The report mounts this in the
 * slot `useReportEndCardSlot` names, and the branch taken here cannot disagree with that
 * placement because both read the same hook.
 *
 * Entitlement is the hook's business, not this component's — it reports `none` and the
 * report mounts nothing.
 */
export const ReportEndCard: React.FC<ReportEndCardProps> = ({
  attentionCount,
  isPql,
}) => {
  const { verdict } = useReportEndCardSlot()
  // Shared with the mobile sticky bar, so the two cannot offer different consult links or
  // different entity copy for the same practice.
  const { taxTreatment, consultUrl, verdictName } = useNextStepsActions(isPql)

  // Non-null only for a decided rejection, which is the one case placed at `end`.
  if (verdict) return <DisqualifiedCard verdict={verdict} />

  return (
    <NextStepsCard
      taxTreatment={taxTreatment}
      attentionCount={attentionCount}
      consultUrl={consultUrl}
      verdict={verdictName}
      isPql={isPql}
    />
  )
}
